function apiBaseUrl() {
  return process.env.REACT_APP_API_BASE_URL;
}

export function apiV2UserTradeSupportingDocuments(
  userID,
  tradeDocumentType,
  tradeDocumentID,
) {
  return `${apiBaseUrl()}/api/v2/users/${userID}/${tradeDocumentType}/${tradeDocumentID}/trade_supporting_documents`;
}

export function apiV2UserTradeSupportingDocument(
  userID,
  tradeDocumentType,
  tradeDocumentID,
  id,
) {
  return `${apiBaseUrl()}/api/v2/users/${userID}/${tradeDocumentType}/${tradeDocumentID}/trade_supporting_documents/${id}`;
}



// WEBPACK FOOTER //
// ./src/features/supporting_documents/apiUrls.js